import moment from 'moment-timezone';

function updateArrBlockedDate(storeArrBlockedDate, arrBlockedDate){
    for(let keyArrBlockedDate in arrBlockedDate){
        storeArrBlockedDate[keyArrBlockedDate] = arrBlockedDate[keyArrBlockedDate];
    }
    return storeArrBlockedDate;
}
function workedTime(storeWorkedTime, arrBlockedDate, workHours, userTimeZone, leadTimeZone, month, year, meetingDuration, breakDuration){
    if(storeWorkedTime === null || typeof storeWorkedTime === "undefined") storeWorkedTime ={}
 //   const createDate = year + '-' + String(String(month).length==1?'0'+ month:month) + '-01 00:00:00';
//    const startDateLead = moment(createDate).startOf('month').format('YYYY-MM-DD HH:mm:ss');
//   const startDateLead = moment().utcOffset(leadTimeZone).format('YYYY-MM-DD HH:mm:ss');
 //   const startDateLead = dateOfTimeZone( year, String(String(month).length==1?'0'+ month:month), '01', '00:00:00', leadTimeZone);

//    let startDateUser = moment(startDateLead).utcOffset(userTimeZone).format('YYYY-MM-DD HH:mm:ss');
//    startDateUser = moment(startDateUser).add(-1, 'd').format('YYYY-MM-DD HH:mm:ss');
    let startDateUser = dateOfTimeZone( year, String(String(month).length==1?'0'+ month:month), '01', '00:00:00', userTimeZone);
    let result = {};
    let storeWorkedTimeKeys = Object.keys(storeWorkedTime);
    if (storeWorkedTimeKeys.length !== 0) {
        storeWorkedTimeKeys.forEach(value => {
            if (moment(value).isBefore(startDateUser)) {
                result[value] = storeWorkedTime[value];
            }
        });
    }

    startDateUser = new Date(startDateUser.getFullYear(),startDateUser.getMonth(),startDateUser.getDate()-1);

//    const endDateLead = moment(createDate).endOf('month').format('YYYY-MM-DD HH:mm:ss');
//    let endDateUser = moment(endDateLead).utcOffset(userTimeZone).format('YYYY-MM-DD HH:mm:ss');
//    endDateUser = moment(endDateUser).add(1, 'd').format('YYYY-MM-DD HH:mm:ss');
    let endDateUser = new Date(startDateUser.getFullYear(),startDateUser.getMonth(),startDateUser.getDate() + 33);

    let sliderTime = startDateUser;
    // eslint-disable-next-line no-unused-vars
    let counterDay = 0;
    let counterSlot = 0;
    let isAllDay = false;
    let allDay = [];
    let dayStartTime;
    let dayEndTime;
    let userDay;
    let userTime;
    let aroundTheClock;


    while (moment(sliderTime).isSameOrBefore(endDateUser)){
        if (workHours[moment(sliderTime).format('dddd').toLowerCase()] != null){
            dayStartTime = dateOfTimeZone( moment(sliderTime).format('YYYY'), moment(sliderTime).format('MM'), moment(sliderTime).format('DD'), timeFromWorkHours(sliderTime, workHours), userTimeZone);
            if (workHours[moment(sliderTime).format('dddd').toLowerCase()].to === 0 ){
                aroundTheClock = new Date(sliderTime.getFullYear(),sliderTime.getMonth(),sliderTime.getDate()+1);
                dayEndTime = dateOfTimeZone( moment(aroundTheClock).format('YYYY'), moment(aroundTheClock).format('MM'), moment(aroundTheClock).format('DD'), timeToWorkHours(sliderTime, workHours), userTimeZone);
            } else {
                dayEndTime = dateOfTimeZone( moment(sliderTime).format('YYYY'), moment(sliderTime).format('MM'), moment(sliderTime).format('DD'), timeToWorkHours(sliderTime, workHours), userTimeZone);
            }
            dayEndTime.setMinutes(dayEndTime.getMinutes() - meetingDuration - breakDuration);
 //           dayEndTime = moment(dayEndTime).add(-breakDuration, 'm');
 //           dayEndTime.setMinutes(dayEndTime.getMinutes() - breakDuration);
            counterSlot = 0;

            while (moment(dayStartTime).isSameOrBefore(dayEndTime)){
                userDay=moment.utc(dayStartTime).utcOffset(userTimeZone).format('YYYY-MM-DD');
                userTime=moment.utc(dayStartTime).utcOffset(userTimeZone).format('HH:mm');

                if (typeof arrBlockedDate[userDay] !== 'undefined') {
                    allDay = arrBlockedDate[userDay].filter(word => word === 'all');
                    isAllDay = (allDay[0] === 'all');
                }

                if (
                    !(typeof arrBlockedDate[userDay] !== 'undefined' && arrBlockedDate[userDay].indexOf(userTime) > -1)
                    && !isAllDay
                ) {
                    result = addSlotStoreWorkedTime(dayStartTime, result, leadTimeZone);
                }
                dayStartTime.setMinutes(dayStartTime.getMinutes() + breakDuration + meetingDuration);

                if (counterSlot>1000) break;
                counterSlot++;
                isAllDay = false;
            }
        }
//        sliderTime = moment(sliderTime).add(1, "d").format('YYYY-MM-DD HH:mm');
        sliderTime = new Date(sliderTime.getFullYear(),sliderTime.getMonth(),sliderTime.getDate()+1);

        if (counterSlot>35) break;
        counterDay ++;
    }
    sortDateShortTime(result)

    return result;
}

function dateOfTimeZone( year, month, day, time, timeZone) {
     return new Date(year + '-' + month + '-' + day + 'T' + time + crmFormatToZFormat(timeZone));
}

function crmFormatToZFormat ( minTimeZone ) {
    var fulltimeZone = null;
    switch(Number( minTimeZone )) {
        case 14: fulltimeZone = "+14:00"; break;
        case 13: fulltimeZone = "+13:00"; break;
        case 12: fulltimeZone = "+12:00"; break;
        case 11: fulltimeZone = "+11:00"; break;
        case 10: fulltimeZone = "+10:00"; break;
        case 9: fulltimeZone = "+09:00"; break;
        case 8: fulltimeZone = "+08:00"; break;
        case 7: fulltimeZone = "+07:00"; break;
        case 6: fulltimeZone = "+06:00"; break;
        case 5: fulltimeZone = "+05:00"; break;
        case 4: fulltimeZone = "+04:00"; break;
        case 3: fulltimeZone = "+03:00"; break;
        case 2: fulltimeZone = "+02:00"; break;
        case 1: fulltimeZone = "+01:00"; break;
        case 0: fulltimeZone = "+00:00"; break;
        case -1: fulltimeZone = "-01:00"; break;
        case -2: fulltimeZone = "-02:00"; break;
        case -3: fulltimeZone = "-03:00"; break;
        case -4: fulltimeZone = "-04:00"; break;
        case -5: fulltimeZone = "-05:00"; break;
        case -6: fulltimeZone = "-06:00"; break;
        case -7: fulltimeZone = "-07:00"; break;
        case -8: fulltimeZone = "-08:00"; break;
        case -9: fulltimeZone = "-09:00"; break;
        case -10: fulltimeZone = "-10:00"; break;
        case -11: fulltimeZone = "-11:00"; break;
        default: fulltimeZone = minTimeZone; break;
    }
    return fulltimeZone;
}

function timeFromWorkHours(dayDate, workHours){
    let timeFrom=workHours[moment(dayDate).format('dddd').toLowerCase()].from;
    if (String(timeFrom).length == 1){
        timeFrom = '0' + timeFrom;
    }
    return timeFrom + ':00';
}
function timeToWorkHours(dayDate, workHours){
    let timeTo=workHours[moment(dayDate).format('dddd').toLowerCase()].to;
    if (String(timeTo).length == 1){
        timeTo = '0' + timeTo;
    }
    return timeTo + ':00';
}

function addSlotStoreWorkedTime(date, leadWorkedTime, leadTimezone){

    const dateNow = new Date();
    if(moment(dateNow).isAfter(date)) return leadWorkedTime;
    const dateLead = moment.utc(date).utcOffset(leadTimezone).format('YYYY-MM-DD');
    const timeLead = moment.utc(date).utcOffset(leadTimezone).format("h:mm A");

    if(typeof leadWorkedTime[dateLead] !== "undefined"){
        let checkVal = leadWorkedTime[dateLead].find((val) => val===timeLead);
        if (typeof checkVal ==="undefined") {
            leadWorkedTime[dateLead].push(timeLead);
        }
    } else {
        leadWorkedTime[dateLead] = [timeLead, ];
    }
    return leadWorkedTime;
}

function createStoreBlockedDate(storeBlockedDate, arrBlockedDate) {
    const keysBlockedDate = Object.keys(arrBlockedDate);

    keysBlockedDate.forEach(keyBlockedDate => {
        const blockedDate = Object.keys(arrBlockedDate[keyBlockedDate]);

        if (arrBlockedDate[keyBlockedDate].length !== 0) {

            if (keyBlockedDate !== 'arrBlockedDate') {
                storeBlockedDate[keyBlockedDate] = Object.keys(arrBlockedDate[keyBlockedDate]);
            }

            if (keyBlockedDate === 'arrBlockedDate' && blockedDate.length) {
                blockedDate.forEach(value => {

                    if (Object.keys(arrBlockedDate[keyBlockedDate][value]).length) {
                        storeBlockedDate[value] = Object.keys(arrBlockedDate[keyBlockedDate][value]);
                    }
                });
            }
        }
    });

    return storeBlockedDate;
}

function sortDateShortTime(objDate){
    Object.keys(objDate).forEach(function(key) {
        this[key].sort((a, b) => {
            const dateA = moment(key + ' ' + a, 'YYYY-MM-DD h:mm A').format('YYYY-MM-DD h:mm A');
            const dateB =moment(key + ' ' + b, 'YYYY-MM-DD h:mm A').format('YYYY-MM-DD h:mm A');

            if(moment(dateA).isBefore(dateB)) return -1
            if(moment(dateA).isAfter(dateB)) return 1




//            localeCompare(a) || b.localeCompare(a)
        });
    }, objDate);
    return objDate;
}

const dayOfWeak = { 0: 'sunday', 1: 'monday', 2: 'tuesday', 3: 'wednesday', 4: 'thursday', 5: 'friday', 6: 'saturday'};

export default {
    updateArrBlockedDate,
    workedTime,
    dayOfWeak,
    crmFormatToZFormat,
    createStoreBlockedDate,
    dateOfTimeZone,
    sortDateShortTime,
}
